var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.sku == 'PICK')?_c('span',{staticClass:"text-sm"},[_vm._v("Surprise me")]):_c('span',{staticClass:"text-sm"},[_vm._v(_vm._s(_vm.flavour.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }